import React from "react"
import PropTypes from "prop-types"

import MetaButton from "@components/MetaButton"
import Markdown from "@components/Markdown"

const ParagraphsWithColumns = ({
  title,
  theme,
  paragraphs,
  className,
  gridClassName,
  defaultTitleClassName,
  ctaBtn,
}) => {
  let background = ""
  let titleTextColor = ""
  let paragraphTextColor = "prose-p:text-bcoral"
  switch (theme) {
    case "blue-bg":
      background = "bg-dblue"
      titleTextColor = "text-white"
      paragraphTextColor = "prose-p:text-bcoral"
      break
    case "white-bg":
      background = "bg-white"
      titleTextColor = "text-dblue"
      paragraphTextColor = "prose-p:text-bcoral"
      break
    default:
      background = "bg-lblue"
      titleTextColor = "text-dblue"
      paragraphTextColor = "prose-p:text-bcoral"
  }
  return (
    <div className={`${className} ${background} py-10 px-6 md:px-11 desk:p-25`}>
      <div className="mx-auto max-w-screen-fhd">
        {title && (
          <h2
            className={`
              ${titleTextColor} ${defaultTitleClassName}
              font-inter text-20 font-normal leading-120% 
              xl:leading-normal mb-2 md:mb-3 
              desk:mb-5 desk:text-40 desk:font-medium
            `}
          >
            {title}
          </h2>
        )}

        <div className={gridClassName}>
          {paragraphs.map(item => (
            <div
              key={item.text}
              className={`${paragraphTextColor} prose
                prose-p:font-inter max-w-none
              prose-p:text-14 desk:prose-p:text-20 
              prose-p:font-normal prose-p:leading-150% md:flex-1 ${
                item.class || ""
              }`}
            >
              <Markdown>{item.text}</Markdown>
            </div>
          ))}
        </div>
        {ctaBtn && (
          <div className={ctaBtn.className}>
            <MetaButton
              onClick={ctaBtn.fn}
              dataEventId={ctaBtn.dataEventId}
              inverted={ctaBtn.inverted}
            >
              {ctaBtn.text}
            </MetaButton>
          </div>
        )}
      </div>
    </div>
  )
}

ParagraphsWithColumns.propTypes = {
  title: PropTypes.string,
  paragraphs: PropTypes.array,
  className: PropTypes.string,
  gridClassName: PropTypes.string,
  defaultTitleClassName: PropTypes.string,
}

ParagraphsWithColumns.defaultProps = {
  className: "",
  gridClassName: "flex flex-col md:flex-row gap-4 xl:gap-8",
  defaultTitleClassName: "",
  paragraphs: [],
}

export default ParagraphsWithColumns
